import { v4 as uuidv4 } from 'uuid'

import {
  getBlockUnratedUrls,
  getExcludeUnrateable,
  getFormattedCustomSegmentIds,
  getFormattedSafetyOptions
} from './helpers'

import {
  BLOCK_UNRATED_URLS,
  CUSTOM_SEGMENT_IDS,
  EXCLUDE_UNRATEABLE,
  SAFETY_OPTIONS
} from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { OPTION_NO, OPTION_YES } from '../../../../../../constants/forms'

export const getInitialValues = targeting => {
  const formattedSafetyOptions = getFormattedSafetyOptions(targeting)
  const excludeUnrateable = getExcludeUnrateable(targeting)
  const formattedCustomSegmentIds = getFormattedCustomSegmentIds(targeting)
  const blockUnratedUrls = getBlockUnratedUrls(targeting)

  return {
    [SAFETY_OPTIONS]: formattedSafetyOptions,
    [CUSTOM_SEGMENT_IDS]: formattedCustomSegmentIds.length ? formattedCustomSegmentIds : [{ text: '', id: uuidv4() }],
    [EXCLUDE_UNRATEABLE]: excludeUnrateable ? OPTION_YES : OPTION_NO,
    [BLOCK_UNRATED_URLS]: blockUnratedUrls
  }
}
